import { inject } from '@angular/core';
import { SavedCartSearchItem, ShoppingCartApi } from '@idealsupply/ngclient-webservice-shopping-cart';
import { signalStore } from '@ngrx/signals';
import { withCachedEntityStore } from 'state-data';

export const SavedCartDetailsStore = signalStore(
  { providedIn: 'root' },
  withCachedEntityStore({
    selectId: (p: SavedCartSearchItem) => '' + p.id,
    load: (id: string) => {
      return inject(ShoppingCartApi).getSavedCart(+id);
    },
  }),
);
